// src/components/Modal.tsx
import React from 'react';

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  variant?: 'default' | 'fullscreen';
  contentClassName?: string;
}

const Modal: React.FC<ModalProps> = ({ children, onClose, variant = 'default', contentClassName = '' }) => {
  const overlayClass = variant === 'fullscreen' ? 'modal-overlay modal-overlay--fullscreen' : 'modal-overlay';
  const contentClass = [
    'modal-content',
    variant === 'fullscreen' ? 'modal-content--fullscreen' : '',
    contentClassName,
  ].filter(Boolean).join(' ');

  return (
    <div className={overlayClass} onClick={onClose}>
      <div className={contentClass} onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
